/**
 * Clamp value within range between min & max
 * @param val
 * @param min
 * @param max
 * @returns
 */
export const clamp = (val: number, min: number, max: number): number => Math.min(Math.max(val, min), max);

export const sanitizeNumericInputInRange = (raw: string, min: number, max: number): string => {
  const digitsOnly = raw.replace(/\D+/g, '');
  if (digitsOnly === '') return String(min);
  const parsed = parseInt(digitsOnly, 10);
  const bounded = clamp(parsed, min, max);
  return String(bounded);
};
